import React from 'react';

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, errorCount: 0 };
  }

  static getDerivedStateFromError(error) {
    const msg = error?.message || '';
    // Suppress DOM portal cleanup errors - non-fatal
    if (
      msg.includes('removeChild') ||
      msg.includes('introuvable') ||
      msg.includes('not a child') ||
      msg.includes('removeChildFromContainer') ||
      msg.includes('The node to be removed')
    ) {
      return { hasError: false };
    }
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const msg = error?.message || '';
    if (
      msg.includes('removeChild') ||
      msg.includes('introuvable') ||
      msg.includes('not a child') ||
      msg.includes('removeChildFromContainer')
    ) {
      return;
    }
    console.error('App error:', error?.message);
    
    // Auto-recover: clear state and reload after 1.5s
    localStorage.removeItem('token');
    setTimeout(() => {
      window.location.href = '/auth';
    }, 1500);
  }

  handleReset = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('theme');
    this.setState({ hasError: false });
    window.location.href = '/auth';
  };

  render() {
    if (this.state.hasError) {
      const isFr = (navigator.language || '').startsWith('fr') || 
                   (localStorage.getItem('language') || 'fr') === 'fr';
      return (
        <div style={{ 
          display: 'flex', alignItems: 'center', justifyContent: 'center', 
          minHeight: '100vh', background: '#07070A', fontFamily: 'Manrope, sans-serif',
          flexDirection: 'column', gap: '16px'
        }}>
          <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: '15px' }}>
            {isFr ? 'Chargement...' : 'Loading...'}
          </p>
          <div style={{ 
            width: '24px', height: '24px', border: '2px solid #F3B33D', 
            borderTopColor: 'transparent', borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }} />
          <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
          <button
            onClick={this.handleReset}
            style={{ 
              marginTop: '16px', padding: '10px 24px', background: '#F3B33D', 
              color: '#07070A', borderRadius: '10px', border: 'none', 
              fontWeight: 600, cursor: 'pointer', fontSize: '14px' 
            }}
          >
            {isFr ? 'Rafraîchir' : 'Refresh'}
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
